import { render, staticRenderFns } from "./SideBarEvents.vue?vue&type=template&id=57df72a7"
import script from "./SideBarEvents.vue?vue&type=script&lang=js"
export * from "./SideBarEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports